import { createContext, useContext, useMemo } from 'react';
import { ReactChildren } from 'src/shared/types/util.types';

interface HostnameContextValue {
  /** Full hostname, e.g. "demo.tekst.ai" or "localhost:3000" */
  hostname: string;
  /** Subdomain portion before the first dot, e.g. "demo" from "demo.tekst.ai" */
  subdomain: string;
  /** Full origin, e.g. "https://demo.tekst.ai" */
  origin: string;
}

const HostnameContext = createContext<HostnameContextValue | undefined>(undefined);

export function useHostname(): HostnameContextValue {
  const context = useContext(HostnameContext);
  if (!context) {
    throw new Error('useHostname must be used within a HostnameProvider');
  }
  return context;
}

export function HostnameProvider({ children }: ReactChildren) {
  const value = useMemo<HostnameContextValue>(() => {
    const hostname = window.location.hostname + (window.location.port ? `:${window.location.port}` : '');
    const subdomain = window.location.hostname.split('.')[0];
    const origin = window.location.origin;

    return { hostname, subdomain, origin };
  }, []);

  return <HostnameContext.Provider value={value}>{children}</HostnameContext.Provider>;
}
